export default function Logo() {
  return (
    <span className="text-primary inline-block font-serif text-[1.75rem] leading-none">
      bumi
    </span>
  )
}
